<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar color="success" dark flat>
      Ввод вручения
    </v-toolbar>

    <v-card-title>

    </v-card-title>
    <v-card-text>
      <v-menu v-model="performDateMenu"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
      >
        <template v-slot:activator="{on}">
          <v-text-field
              label="Дата вручения"
              v-model="performDisplayValue"
              readonly
              v-on="on"
          />
        </template>
        <v-date-picker
            v-model="performDate"
            @change="onPerformDateChanged"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :min="performDateMinValue"
            :max="performDateMaxValue"
        />
      </v-menu>

      <v-text-field v-model="recipient" v-if="isRecipientRequired"
                    placeholder="ФИО получателя письма"
                    :error-messages="recipientErrorMessages"
                    :counter="200"
      />

      <v-textarea v-model="note"
                  :auto-grow="true"
                  :clearable="true"
                  :filled="true"
                  placeholder="Дополнительная информация"
      />


    </v-card-text>
    <v-card-actions>
      <v-btn color="default" text @click="onCloseClicked" :disabled="loading">Закрыть</v-btn>
      <v-spacer/>
      <v-btn color="success" dark @click="onPerformClicked" :disabled="loading">Сохранить</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isPerformFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить вручение
    </v-snackbar>
  </v-card>
</template>

<script>
import Moment from "moment";
import {required, minLength, maxLength} from 'vuelidate/lib/validators'
import MailService from '../../../services/mail.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {Delivered} from "@/enums/perform.type";
import {APP_MAIL_PERFORMED} from "@/store/modules/app/actions";
import {NBU, OSM, PSB} from "@/enums/client";
import PostIndexService from "@/services/post.index.service";

export default {
  name: "SuccessDeliveredPerform",
  props: {
    mailHistory : {
      type: Array,
      default: null
    },
    mail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      recipient: null,
      note: null,
      performDate: null,
      performDisplayValue: '',
      performDateMenu: false,

      loading: false,
      isPerformFailed: false
    }
  },
  computed: {
    performDateMinValue() {
      const filteredHistory = this.mailHistory.filter(m => m.type.id === 4);
      const lastFilteredItem = filteredHistory.pop();

      const currentDate = new Date();
      const twoDaysAgo = new Date(currentDate);
      twoDaysAgo.setDate(currentDate.getDate() - 2);
      let minDate;
      let lastItemDate;

      if (lastFilteredItem && lastFilteredItem.perform && lastFilteredItem.perform.performedOn) {
        lastItemDate = new Date(lastFilteredItem.perform.performedOn);
        lastItemDate.setHours(0, 0, 0, 0);

        if (lastItemDate < twoDaysAgo && Date(this.mail.createdOn) < twoDaysAgo) {
          minDate = twoDaysAgo;
        }else if (twoDaysAgo < lastItemDate && Date(this.mail.createdOn) < lastItemDate) {
          minDate = lastItemDate;
        }else {
          minDate = this.mail.createdOn
        }
      } else {
        if(this.mail.createdOn < twoDaysAgo){
            minDate = twoDaysAgo;
          }
          else{
            minDate = this.mail.createdOn;
          }
      }
      return minDate.toISOString(true);
    },
    performDateMaxValue() {
      return Moment().toISOString(true)
    },
    isRecipientRequired() {
      return this.mail && (this.mail.client === OSM || this.mail.client === PSB || this.mail.client === NBU)
    },
    recipientErrorMessages() {
      const errors = []

      if (this.isRecipientRequired && this.$v.recipient.$dirty) {
        if (!this.$v.recipient.required)
          errors.push(`Введите полное имя кому было вручено письмо`)
        else {
          !this.$v.recipient.minLength && errors.push(`Слишком короткое значение`)
          !this.$v.recipient.maxLength && errors.push(`Слишком длинное значение`)
        }
      }
      return errors
    }
  },
  validations() {
    let validations = {
      performDate: {
        required
      }
    }

    if (this.isRecipientRequired)
      validations.recipient = {
        required,
        minLength: minLength(1),
        maxLength: maxLength(200)
      }

    return validations
  },
  methods: {
    clear() {
      this.recipient = null
      this.note = null
      this.performDate = null
      this.performDisplayValue = ''

      this.$v.$reset()
    },
    onCloseClicked() {
      this.clear()
      this.$emit('close')
    },
    onPerformDateChanged() {
      if (this.performDate) {
        this.performDisplayValue = Moment(this.performDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      } else {
        this.performDisplayValue = ''
      }

      this.performDateMenu = false
    },
    onPerformClicked() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const performType = Delivered

        this.loading = true
        this.isPerformFailed = false
        this.$store.dispatch(LAYOUT_LOADING_START)
        MailService.perform({
          mail: this.mail,
          performType: performType,
          performDate: this.performDate ? Moment(this.performDate, 'YYYY-MM-DD') : null,
          note: this.note,
          recipient: this.recipient
        })
            .then(() => {
              PostIndexService.updatePostIndex({id: this.mail.id, postIndex: this.mail.postPackage.postCode})
              this.clear()
              this.$store.dispatch(APP_MAIL_PERFORMED, {mail: this.mail, performType: performType})
            })
            .catch(() => {
              this.isPerformFailed = true
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            });
      }
    }
  },
  created() {
    if (this.mail.isPerformed) {
      this.performDate = this.mail.perform.performedOn.format('YYYY-MM-DD');
      this.onPerformDateChanged()
    }
  }
}
</script>

<style scoped>

</style>
